import useFeatureFlags from "./useFeatureFlag";
import useUsers from "./useUsers";
import { userCanAccessCRO } from "../util";

export default function useCanAccessCRO(): boolean {
  const flag = useFeatureFlags();
  const usersState = useUsers();
  return userCanAccessCRO(flag("freshpaintAiChat"), usersState.currentUser);
}
